import {Injectable} from '@angular/core';

@Injectable({providedIn: 'root'})
export class CompareService {

	/**
	 * Permet de comparer deux valeurs par code
	 *
	 * @param valeur1 premiere valeur
	 * @param valeur2 deuxième valeur
	 */
	comparerParCode(valeur1: any, valeur2: any): boolean {
		return valeur1 && valeur2 ? valeur1.code === valeur2.code : valeur1 === valeur2;
	}

	/**
	 * Permet de comparer deux valeurs par désignation
	 *
	 * @param valeur1 premiere valeur
	 * @param valeur2 deuxième valeur
	 */
	comparerParDesignation(valeur1: any, valeur2: any): boolean {
		return valeur1 && valeur2 ? valeur1.designation === valeur2.designation : valeur1 === valeur2;
	}
}
